import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Table } from 'react-bootstrap'
import { useStateValue } from '../../state'
import { client } from '@Utils'

const platformNameMap = {
  blackboard: 'Blackboard',
  desire2learn: 'Brightspace',
  canvas: 'Canvas',
  moodle: 'Moodle',
  myed: 'MyEducator Platform',
  all: 'All Platforms',
}

export const Platforms = ({ match }) => {
  const [currentState, dispatch] = useStateValue()
  useEffect(() => {
    const getPlatforms = async () => {
      try {
        const lmsCode = match.params.lmsCode ? match.params.lmsCode : 'all'
        const resp = await client.get(
          `/account/admin_lti13.getIssuers/-/${lmsCode}`
        )
        dispatch({ type: 'updateMessage', message: null })
        dispatch({ type: 'updateTable', tableData: resp.data.issuers })
      } catch (err) {
        if (err.response.status > 205) {
          dispatch({ type: 'updateMessage', message: err.response.statusText })
        } else {
          dispatch({ type: 'updateMessage', message: err })
        }
      }
    }
    getPlatforms()
  }, [])

  return (
    <div className="container" style={{ width: '100%' }}>
      <div className="mb-2 go-back-button-left-align">
        <a
          className="btn btn-default btn-myed btn-default-myed btn-sm-myed mr-4"
          href="/account/admin_lti13/-/"
        >
          <div className="far fa-arrow-circle-left fa-fw mr-2" /> Go Back
        </a>
      </div>
      <div className="card-myed">
        <h3>Issuers for {platformNameMap[match.params.lmsCode]}:</h3>
        <Table striped bordered condensed hover>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Issuer</th>
              <th>Code</th>
              <th>Authorization URL</th>
            </tr>
          </thead>
          <tbody>
            {currentState.tableData.map((platform, i) => (
              <tr key={i}>
                <td>{platform.id}</td>
                <td>{platform.data.name}</td>
                <td>{platform.iss}</td>
                <td>{platform.data.product_family_code}</td>
                <td>
                  <p>OIDC: {platform.data.auth_url}</p>
                  <p>JWT: {platform.data.token_url}</p>
                </td>
                <td>
                  <Link
                    to={`/account/admin_lti13/-/platforms/${match.params.lmsCode}/issuers/${platform.id}`}
                  >
                    View Issuer
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  )
}
